import { Redirect } from 'react-router-dom';

type Props = { basePath: string };

export const RedirectToBase = ({ basePath }: Props) => (
    <Redirect to={basePath} />
);
